import React from "react";
import { Link } from "react-router-dom";
import DefaultData from "../../CompanyData/DefaultData"; // Adjust path if needed

const AccountTabs = (props) => {
  const baseTabStyle = {
    border: "none",
    fontWeight: "500",
    padding: "0.75rem 1.5rem",
    borderRadius: "0.375rem 0.375rem 0 0",
  };
  const inactiveTabStyle = {
    ...baseTabStyle,
    backgroundColor: "transparent",
    color: DefaultData.THEMECOLOR3,
    opacity: 2,
  };
  const activeTabStyle = {
    ...baseTabStyle,
    backgroundColor: DefaultData.THEMECOLOR2,
    color: DefaultData.THEMECOLOR3,
  };
  const getStyle = (pageName) =>
    props.pageName === pageName ? activeTabStyle : inactiveTabStyle;

  return (
    <div
      style={{
        backgroundColor: DefaultData.THEMECOLOR5,
        padding: "0 1rem",
        borderBottom: `1px solid ${DefaultData.THEMECOLOR2}`,
      }}
    >
      <ul className="nav nav-tabs" style={{ borderBottom: "none" }}>
        <li className="nav-item" role="presentation">
         <Link
            to={"/accounts-dashboard"}
            className="nav-link"
            style={getStyle("ACCOUNTDASHBOARD")}
          >
            DASHBOARD
          </Link>
        </li>

        {/* <li className="nav-item" role="presentation">
          
          <Link
            to={"/saleinvoice"}
            className="nav-link"
            style={getStyle("SALEINVOICE")}
          >
            SALE INVOICE
          </Link>
        </li> */}

        <li className="nav-item" role="presentation">
          <Link
            to={"/salelist"}
            className="nav-link"
            style={getStyle("SALELIST")}
          >
            SALES 
          </Link>
        </li>
        {/* <li className="nav-item" role="presentation">
          <Link
            to={"/purchaseinvoice"}
            className="nav-link"
            style={getStyle("PURCHASEINVOICE")}
          >
            PURCHASE INVOICE
          </Link>
        </li> */}
        <li className="nav-item" role="presentation">
          <Link
            to={"/purchaselist"}
            className="nav-link"
            style={getStyle("PURCHASELIST")}
          >
            PURCHASES
          </Link>
        </li>
        {/* <li className="nav-item" role="presentation">
          <Link
            to={"/expenseinvoice"}
            className="nav-link"
            style={getStyle("EXPENSEINVOICE")}
          >
            EXPENSE INVOICE
          </Link>
        </li> */}
        <li className="nav-item" role="presentation">
          <Link
            to={"/expenselist"}
            className="nav-link"
            style={getStyle("EXPENSELIST")}
          >
            EXPENSES 
          </Link>
        </li>
        {/* <li className="nav-item" role="presentation">
          <Link
            to={"/salesreport"}
            className="nav-link"
            style={getStyle("SALESREPORT")}
          >
            SALE REPORT
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link
            to={"/purchasesReport"}
            className="nav-link"
            style={getStyle("PURCHASESREPORT")}
          >
            PURCHASE REPORT
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link
            to={"/invoicereport"}
            className="nav-link"
            style={getStyle("INVOICEREPORT")}
          >
            INVOICE REPORT
          </Link>
        </li> */}
        <li className="nav-item" role="presentation">
          <Link to={"/cheques"} className="nav-link" style={getStyle("CHEQUE")}>
            CHEQUES
          </Link>
        </li>
         <li className="nav-item" role="presentation">
          <Link to={"/profit-loss-detailedreport"} className="nav-link" style={getStyle("PROFITLOSSDETAILEDREPORT")}>
            PROFIT&LOSS 
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link to={"/supplier-ledger"} className="nav-link" style={getStyle("SUPPLIERLEDGER")}>
            SUPPLIER LEDGER
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link to={"/agent-ledger"} className="nav-link" style={getStyle("AGENTLEDGER")}>
            AGENT LEDGER
          </Link>
        </li>
          <li className="nav-item" role="presentation">
                 <Link
                   to={"/companybankaccounts"}
                   className="nav-link"
                   style={getStyle("COMPANYBANK")}
                 >
                    BANKACCOUNTS
                 </Link>
               </li>
               
 <li className="nav-item" role="presentation">
          <Link to={"/items"} className="nav-link" style={getStyle("ITEMS")}>
            ITEMS
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link
            to={"/accountitems"}
            className="nav-link"
            style={getStyle("ACCOUNTITEMS")}
          >
            ACCOUNT ITEMS
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default AccountTabs;
